var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxisX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03 6.16016L3.51 4.03216L2.006 6.16016H0.822L2.902 3.30416L0.934 0.560156H2.11L3.542 2.55216L4.958 0.560156H6.086L4.126 3.26416L6.23 6.16016H5.03Z",
    fill: "#ACAFB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxisX);
export default __webpack_public_path__ + "static/media/axis_x.649960a2410f6d64e587c09bc77d8347.svg";
export { ForwardRef as ReactComponent };